import React from 'react'
import VideoReaction from '@/Pages/VideoPlayer/components/VideoReaction';
import VideoTags from '@/Pages/VideoPlayer/components/VideoTags';
import "@/Pages/VideoPlayer/PlayerPage.css"
import TRC_CONTENT from '@/constants/trcContentType';
import TRC_FILE_TYPE from '@/TRC/constants/trcFileType';
import { videoHasTags } from '@/utils/checkTags';

const TRCVideoDescription = ({ selectedVideo }) => {
    const tagsPresent = videoHasTags(selectedVideo);
    return (
        <div className="trc-description-container">
            <div className="c-video_description">
                <div>
                    <div className="c-video_description-h4">
                        <h1>{selectedVideo?.title}</h1>
                        <VideoReaction videoId={selectedVideo?._id} type={TRC_CONTENT.TRC} />
                    </div>
                    <div className="c-video_description-tag_trc d-flex gap-2 align-items-start">
                        {tagsPresent && (
                            <VideoTags tags={selectedVideo?.tagsDetails} type={TRC_CONTENT.TRC} />
                        )}
                        {selectedVideo?.fileType === TRC_FILE_TYPE.PDF && <span className="c-video_description-tag-span text-white">{selectedVideo?.pages} pages</span>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TRCVideoDescription